import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment";
import "moment/locale/tr";

i18n
  .use(HttpApi) // Load translations from the backend
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass the i18n instance to react-i18next
  .init({
    supportedLngs: ["en", "tr"], // List of supported languages
    fallbackLng: "en", // Fallback language
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator", "htmlTag"],
      caches: ["cookie", "localStorage"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json", // Translation files location
    },
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });
// Set moment locale when language changes
i18n.on("languageChanged", (lng) => {
  moment.locale(lng);
});

export default i18n;
